import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoNewImage from '../../assets/images/logo_new.png';
import hensImg from '../../assets/images/hens.jpeg';
import css from './OurTeamPage.module.css';

import { Page } from '../../components';
import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './OurTeamPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import ourTeamFooter from '../../assets/images/ourTeamFooter.png';


export const OurTeamPageComponent = props => {
  const { pageAssetsData } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.OurTeamPage}
        style={{
          backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/ourTeam.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            <img src={logoNewImage} alt="Farmiez Logo" className={css.faqLogo} />
            <h1 className={css.heroTitle}>Our Team</h1>
          </div>
          
        </div>

        <div 
          className={css.aboutContentWrap}
          // style={{
          //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
          // }}
        >
          {/* Content Section */}
          <div className={css.contentSection}>
            <p className={css.intro}>Farmiez is built by a small but mighty team of local food lovers, digital innovators, and community builders who believe in one simple thing:</p>
            <div className={css.textBlock}>
              <ul className={css.faqList}>
                <li>Good food should come from nearby—and from people you can trust.</li>
                <li>From tech and design to support and sustainability, every decision we make centers around helping small growers thrive and helping families eat better.</li>
                <li><strong>We’re growing fast—and you’re part of the story.</strong>
                </li>
              </ul>
            </div>
          </div>

          <img src={ourTeamFooter} alt="img" className={css.footerImg} />

        </div>
        <FooterContainer />
      </div>
    </Page>
  );
};

OurTeamPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const OurTeamPage = compose(connect(mapStateToProps))(OurTeamPageComponent);

export default OurTeamPage;
